import { ONE_LINK_BASE_URL } from "../constants";

function generateOneLinkURL(webContext, product) {
  const affId = webContext.affiliateId
    ? `&affid=${webContext.affiliateId}`
    : "";
  const customerRef = webContext.customerId
    ? `&custref=${webContext.customerId}`
    : "";

  const queryParams = new URLSearchParams({
    pid: "qr_code",
    c: "pdp-app-download",
    deep_link_value: `asos://prd?iid=${product.id}channelref=pdp-app-download${affId}${customerRef}`,
  });

  return `${ONE_LINK_BASE_URL}?${queryParams.toString()}`;
}

export { generateOneLinkURL };
